import { memo, useCallback } from 'react';
import { useDispatch } from '@betty/toolkit/state';
import { resetToRootNavigator } from '@betty/navigation';
import { Button, InfoImage, ScrollView } from '@betty/moonlight';
import { openChat } from '@betty/chat/state';

function PaymentNotAvailable() {
  const dispatch = useDispatch();

  const onContactSupport = useCallback(() => {
    dispatch(openChat());
  }, [dispatch]);

  const onGoHome = useCallback(() => {
    resetToRootNavigator();
  }, []);

  return (
    <ScrollView
      contentContainerStyle={{
        padding: 'space-400',
        paddingBottom: 'safe-area-inset-bottom',
        minHeight: '100%',
      }}
    >
      <InfoImage
        titleNS="wallet"
        titleKey="paymentNotAvailableTitle"
        descriptionNS="wallet"
        descriptionKey="paymentNotAvailableDescription"
      />
      <Button
        locNS="common"
        locKey="contactSupport"
        size="large"
        marginTop="auto"
        onPress={onContactSupport}
      />
      <Button
        variant="secondary"
        locNS="common"
        locKey="home"
        size="large"
        marginVertical="space-200"
        onPress={onGoHome}
      />
    </ScrollView>
  );
}

export default memo(PaymentNotAvailable);
